import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

type RegisterResultModalProps = {
  isShow: boolean,
  user: IUser,
  toggle: any,
}

export const RegisterResultModal: React.SFC<RegisterResultModalProps> = ({isShow, user, toggle}) => {
  return (
    <Modal isOpen={isShow} toggle={toggle}>
      <ModalHeader>Đăng ký thành công</ModalHeader>
      <ModalBody>
        Bạn đã đăng ký thành công với tên tài khoản là : {user.username}. Xin vui lòng xác thực Email của bạn để có thể
        sử dụng đầy đủ chức năng của hệ thống. Chúng tôi đã gửi email xác thực vào hòm thư của bạn: {user.email}.
        Nếu không nhận được email, bạn vui lòng kiểm tra lại hòm thư Spam.
        Trong thời gian 5 phút, nếu bạn vẫn không nhận được mail xác thực ở trong hộp thư đến cũng như
        trong hòm thư Spam. Bạn vui lòng liên hệ với chúng tôi <a href={'https://m.me/kuhau2103'}>tại đây</a>.
        Xin cảm ơn!
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Đóng</Button>
      </ModalFooter>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Register/components/RegisterResultModal.tsx